export const DOM_MAPPING_NAME = "_mapping";